import Http from "@/libs/axios";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    opList: [],
    op: null,
    opTypeOptions: [],
    opAmountOptions: [],
    couponTypeOptions: [],
  },
  getters: {
    opList: (state) => {
      return state.opList;
    },
    opTypeOptions: (state) => {
      return state.opTypeOptions;
    },
    opAmountOptions: (state) => {
      return state.opAmountOptions;
    },
    couponTypeOptions: (state) => {
      return state.couponTypeOptions;
    },
  },
  mutations: {
    SET_OP_LIST(state, ops) {
      state.opList = ops;
    },
    SET_OP(state, op) {
      state.op = op;
    },
    SET_OP_TYPE_OPTIONS(state, opTypes) {
      state.opTypeOptions = opTypes;
    },
    SET_OP_AMOUNT_OPTIONS(state, opAmounts) {
      state.opAmountOptions = opAmounts;
    },
    SET_COUPON_TYPE_OPTIONS(state, couponTypes) {
      state.couponTypeOptions = couponTypes;
    },
  },
  actions: {
    getList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Http.get("op", { params: params })
          .then((response) => {
            commit("SET_OP_LIST", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },
    getOpTypeOptions({ commit }) {
      return new Promise((resolve, reject) => {
        Http.get("op/type-options")
          .then((response) => {
            commit("SET_OP_TYPE_OPTIONS", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },
    getOpAmountOptions({ commit }) {
      return new Promise((resolve, reject) => {
        Http.get("op/amount-options")
          .then((response) => {
            commit("SET_OP_AMOUNT_OPTIONS", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },
    getCouponTypeOptions({ commit }) {
      return new Promise((resolve, reject) => {
        Http.get("op/coupon-type-options")
          .then((response) => {
            commit("SET_COUPON_TYPE_OPTIONS", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },
    create({}, { payload }) {
      return new Promise((resolve, reject) => {
        payload.rec_date = moment(payload.rec_date).format("YYYY-MM-DD");
        Http.post("op", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    issuedEntry({}, { payload }) {
      return new Promise((resolve, reject) => {
        payload.rec_date = moment(payload.rec_date).format("YYYY-MM-DD");
        Http.post("op/issued-entry", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    update({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.put(`op/${payload.City}/${payload.Opno}`, payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    cancel({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("op/cancel", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    returnToStock({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("op/return-to-stock", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    markPay({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("op/mark-pay", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    markUnpaid({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("op/mark-unpaid", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    getPaymentDetailsByCriteria({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("op/payment-details-by-criteria", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    getPaymentListByCriteria({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("op/payment-list-by-criteria", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    updatePaymentEntry({}, { payload }) {
      return new Promise((resolve, reject) => {
        Http.post("op/update-payment", payload)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    show({ commit }, id) {
      return new Promise((resolve, reject) => {
        Http.get(`op/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    showDetails({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Http.get(`op/details/${payload.City}/${payload.Opno}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    generateSummaryReportView({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Http.post("op/generate-summary-report-view", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    processPaymentUpdate({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/process-payment-update", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    retrievePostedData({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/retrieve-posted-receipt", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    retrieveDiscrepancyData({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/retrieve-discrepancy-receipt", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    downloadDiscrepancyReport({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/generate-discrepancy-report", data, {
          responseType: "arraybuffer",
        })
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    updatePaymentReceipt({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/update-receipt", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    deletePayment({}, id) {
      return new Promise((resolve, reject) => {
        Http.delete(`op/delete-payment/${id}`)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    retrieveOpReceipt({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/retrieve-receipt", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    updateReceipts({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/update-receipts", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    deleteReceipts({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/delete-receipts", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    exportOverdueOPNData({}, data) {
      return new Promise((resolve, reject) => {
        Http.post("op/export-overdue-opn-data", data)
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      });
    },
    getCouponNoInfo({ commit }, couponNo) {
      return new Promise((resolve, reject) => {
        Http.get(`op/coupon/${couponNo}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
